import { snackbar } from "@mobiscroll/react5";
import { APPROVE_BANK_DETAILS } from "src/components/graphql/GraphQLmutation";
import { getQuery, postMutation } from "src/components/ApolloConnection/ApolloProviderComponent";
import { LIST_BANK_DETAILS_REQUEST } from "src/components/graphql/GraphQLquery";

const BANK_DETAILS_LIST_TAKE = 100;

export async function listBankDetailRequests(status) {
    try {
        const response = await getQuery(
            LIST_BANK_DETAILS_REQUEST,
            { take: BANK_DETAILS_LIST_TAKE, skip: 0, status: status ?? null },
            true,
        );

        if (!response || response.errors) {
            throw new Error(response?.errors?.[0]?.message || "Failed to fetch bank detail requests");
        }

        const result = response?.data?.listBankDetails;

        if (result?.statusCode && result.statusCode >= 400) {
            throw new Error(result?.message || "Failed to fetch bank detail requests");
        }

        if (result?.data) {
            return {
                items: result.data,
                totalCount: result.totalCount ?? result.data.length,
            };
        }

        throw new Error("No data found in bank detail requests");
    } catch (e) {
        snackbar({ message: e.message || "Error fetching bank detail requests. Try again", color: "danger", });
        console.error("Error at fetching bank detail requests ", e);
        throw e;
    }
}

export async function confirmBankDetails(data) {
    try {
        const response = await postMutation(APPROVE_BANK_DETAILS, data, true);
        if (
            response.data !== null &&
            response?.data?.updateClinicRazorpayAccountId?.statusCode >= 200 &&
            response?.data?.updateClinicRazorpayAccountId?.statusCode < 300
        ) {
            snackbar({
                message: response?.data?.updateClinicRazorpayAccountId?.message,
                color: "success",
            });
            return true;
        } else {
            const errMsg = response?.data?.updateClinicRazorpayAccountId?.message || "Failed to link Razorpay account";
            throw new Error(errMsg);
        }
    } catch (error) {
        snackbar({ message: error.message, color: "danger", });
        console.error("Error approving bank details ", error);
        // return [];
        throw error;
    }
}